import styled from "styled-components";

export const Button = styled.button`
  width: 100%;
  height: 40px;
  background-color: black;
  border-radius: 60px;
  transition: transform 0.2s, background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    transform: ${(props) => (props.disabled ? "scale(1)" : "scale(1.1)")};
    background-color: ${(props) => (props.disabled ? "black" : "#007bff")};
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};

    @media (max-width: 728px) {
      transform: none;
      background-color: black;
    }
  }
`;
